import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import pretty from "Shared/pretty";
import { UserExternalIDKind } from "Shared/types/EmployeeProfiles";
import { DPEmployeeProfile } from "Shared/types/EmployeeProfiles";
import DataTable from "Components/Shared/DataTable/DataTable";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import useStyles from "./styles";

type Props = {
  externalIds: DPEmployeeProfile["externalIds"];
}

function formatIdentifierKindToLabel(identifier: UserExternalIDKind) {
  return pretty.startCase(identifier).replace("Id", "ID");
}

const IdentifiersTable: FC<Props> = ({ externalIds }) => {
  const classes = useStyles();

  return (
    <DataTable title="Identifiers">
      {externalIds.map((identifier, idx) => (
        <DataTableRow key={idx}>
          <Typography>
            {`${identifier.kind === UserExternalIDKind["external_id"]
              ? "User ID"
              : formatIdentifierKindToLabel(identifier.kind as UserExternalIDKind)}:`}
          </Typography>
          <Typography className={classes.detail}>
            {identifier.id}
          </Typography>
        </DataTableRow>
      ))}
    </DataTable>
  );
};

export default IdentifiersTable;
